import s from './Section.scss'
import { timezoneDate } from 'utils/helpers'
import { Table } from 'reactstrap'
import capitalize from 'lodash/capitalize'

const Section = ({ logs, title }) => (
  <div className={s.section}>
    <div className={s.header}>{title}</div>
    <Table borderless size="sm">
      <tbody>
        {logs.map((log, index) => (
          <tr className={s.log} key={index}>
            <td style={{ width: '20%' }} className={s.minWidth}>
              {timezoneDate(log.date, 'HH:mm A')}
            </td>
            <td style={{ width: '20%' }} className={s.minWidth}>
              {log.user ? `${log.user.firstName} ${log.user.lastName}` : '-'}
            </td>
            <td style={{ width: '10%' }}>{capitalize(log.entityType)}</td>
            <td style={{ width: '50%' }}>{log.activityLog}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
)

export default Section
